import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ChevronRight, Camera } from 'lucide-react';

const TrialRoomHomeWidget = () => {
  return (
    <section className="py-8 px-4" data-testid="trial-room-home-widget">
      <div className="max-w-7xl mx-auto">
        <style>{`@keyframes trial-blink-home { 0%,49%{opacity:1}50%,100%{opacity:.4} }`}</style>
        <Link to="/trial-room" className="block group">
          <div className="rounded-3xl border-2 border-cyan-400/40 bg-gradient-to-br from-cyan-900/25 via-fuchsia-900/25 to-amber-900/25 p-6 lg:p-8 backdrop-blur-sm relative overflow-hidden hover:border-cyan-300 transition-all">
            {/* Shimmer */}
            <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ background: 'radial-gradient(circle at 15% 25%, rgba(6,182,212,0.35) 0%, transparent 40%), radial-gradient(circle at 85% 75%, rgba(236,72,153,0.32) 0%, transparent 40%)' }} />
            <div className="relative">
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <span className="text-cyan-300 font-extrabold text-xs tracking-widest" style={{ animation: 'trial-blink-home 1s infinite' }}>🚀 NEW · AI VISION EDITION 🚀</span>
                <span className="text-xs px-2 py-1 bg-emerald-500/30 text-emerald-100 rounded-full font-semibold">2 FREE TRIALS + PAY-PER-USE</span>
                <span className="text-xs px-2 py-1 bg-amber-500/30 text-amber-100 rounded-full font-semibold">🏷️ YOUR OWN BRANDING</span>
                <span className="text-xs px-2 py-1 bg-fuchsia-500/30 text-fuchsia-100 rounded-full font-semibold">PRIVACY-FIRST</span>
              </div>
              <div className="flex items-start justify-between flex-wrap gap-3">
                <div className="flex-1 min-w-[240px]">
                  <h2 className="text-3xl lg:text-5xl font-black bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-amber-300 bg-clip-text text-transparent">🪞 ANANT AI TRIAL ROOM</h2>
                  <div className="italic text-slate-200 text-sm md:text-base mt-1">Virtual try-on for Apparels · Jewelry · Hair & Makeup — Har try-on pe <b className="text-amber-300">aap ka shop logo &amp; naam</b> auto-watermark!</div>
                  <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-2 max-w-xl">
                    <div className="rounded-lg bg-white/5 border border-white/10 p-2 text-center">
                      <Camera className="w-5 h-5 mx-auto text-cyan-300 mb-1" />
                      <div className="text-[10px] font-bold text-white">Live Camera</div>
                      <div className="text-[9px] text-slate-400">Jewelry · Salon</div>
                    </div>
                    <div className="rounded-lg bg-white/5 border border-white/10 p-2 text-center">
                      <Sparkles className="w-5 h-5 mx-auto text-fuchsia-300 mb-1" />
                      <div className="text-[10px] font-bold text-white">AI Stylist</div>
                      <div className="text-[9px] text-slate-400">Best Picks + Advice</div>
                    </div>
                    <div className="rounded-lg bg-white/5 border border-white/10 p-2 text-center">
                      <div className="text-xl mx-auto">📤</div>
                      <div className="text-[10px] font-bold text-white">Photo Upload</div>
                      <div className="text-[9px] text-slate-400">Apparels Try-On</div>
                    </div>
                  </div>
                </div>
                <div className="text-right" data-testid="trial-home-price">
                  <div className="text-[10px] uppercase tracking-widest text-amber-300 font-black">Pay-per-trial</div>
                  <div className="text-3xl md:text-5xl font-black text-white">25<span className="text-sm opacity-80 ml-1">AT</span></div>
                  <div className="text-[11px] text-emerald-300 font-black">per trial · min 2</div>
                  <div className="text-[9px] text-slate-400 mt-0.5">Or Tester Pack — 200 AT / 10 trials</div>
                  <div className="mt-2 inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-gradient-to-r from-cyan-500 to-fuchsia-500 text-white text-xs font-black group-hover:scale-105 transition">
                    Try Free <ChevronRight className="w-3 h-3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default TrialRoomHomeWidget;
